import { ICourseCatalogOverviewQuery } from '../interfaces/course-catalog-overview.query.interface';
import { CourseCatalogOverviewCategory } from './course-catalog-overview-category.model';

// @dynamic
export class CourseCatalogOverview {
    id: string;
    title: string;
    categories: CourseCatalogOverviewCategory[];

    constructor(query?: ICourseCatalogOverviewQuery) {
        if (query) {
            this.id = query.id.toString();
            this.title = query.title;
            this.categories = query.categories?.length ? query.categories.map((category) => new CourseCatalogOverviewCategory(category)) : [];
        }
    }
}
